export type UpdateProjectMemoResponse = {
  updateDateTime: string;
};
